import { TenantEntity } from '../TenantEntity'

export class FinanceAp extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FinanceAp'
  }

  get branchId() {
    return this._data.branchId
  }

  set branchId(branchId) {
    this._data.branchId = branchId
  }

  get tentativeEstimateNo() {
    return this._data.tentativeEstimateNo
  }

  set tentativeEstimateNo(tentativeEstimateNo) {
    this._data.tentativeEstimateNo = tentativeEstimateNo
  }

  get accountingDate() {
    return this._data.accountingDate
  }

  set accountingDate(accountingDate) {
    this._data.accountingDate = accountingDate
  }

  get applyDate() {
    return this._data.applyDate
  }

  set applyDate(applyDate) {
    this._data.applyDate = applyDate
  }

  get excludingTaxAmount() {
    return this._data.excludingTaxAmount
  }

  set excludingTaxAmount(excludingTaxAmount) {
    this._data.excludingTaxAmount = excludingTaxAmount
  }

  get amount() {
    return this._data.amount
  }

  set amount(amount) {
    this._data.amount = amount
  }

  get currency() {
    return this._data.currency
  }

  set currency(currency) {
    this._data.currency = currency
  }

  get invoiceTitle() {
    return this._data.invoiceTitle
  }

  set invoiceTitle(invoiceTitle) {
    this._data.invoiceTitle = invoiceTitle
  }

  get taxRate() {
    return this._data.taxRate
  }

  set taxRate(taxRate) {
    this._data.taxRate = taxRate
  }

  get priority() {
    return this._data.priority
  }

  set priority(priority) {
    this._data.priority = priority
  }

  get prepay() {
    return this._data.prepay || 0
  }

  set prepay(prepay) {
    this._data.prepay = prepay
  }

  get invoiceType() {
    return this._data.invoiceType
  }

  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType
  }

  get invoiceCloudState() {
    return this._data.invoiceCloudState
  }

  set invoiceCloudState(invoiceCloudState) {
    this._data.invoiceCloudState = invoiceCloudState
  }

  get receiveType() {
    return this._data.receiveType
  }

  set receiveType(receiveType) {
    this._data.receiveType = receiveType
  }

  get receiveAccount() {
    return this._data.receiveAccount
  }

  set receiveAccount(receiveAccount) {
    this._data.receiveAccount = receiveAccount
  }

  get recipientBank() {
    return this._data.recipientBank
  }

  set recipientBank(recipientBank) {
    this._data.recipientBank = recipientBank
  }

  get swiftCode() {
    return this._data.swiftCode
  }

  set swiftCode(swiftCode) {
    this._data.swiftCode = swiftCode
  }

  get remark() {
    return this._data.remark
  }

  set remark(remark) {
    this._data.remark = remark
  }

  get payNo() {
    return this._data.payNo
  }

  set payNo(payNo) {
    this._data.payNo = payNo
  }

  get processNo() {
    return this._data.processNo
  }

  set processNo(processNo) {
    this._data.processNo = processNo
  }

  get apState() {
    return this._data.apState
  }

  set apState(apState) {
    this._data.apState = apState
  }

  get billPaymentState() {
    return this._data.billPaymentState
  }

  set billPaymentState(billPaymentState) {
    this._data.billPaymentState = billPaymentState
  }

  get writeOffStatus() {
    return this._data.writeOffStatus
  }

  set writeOffStatus(writeOffStatus) {
    this._data.writeOffStatus = writeOffStatus
  }

  get bankCurrency() {
    return this._data.bankCurrency
  }

  set bankCurrency(bankCurrency) {
    this._data.bankCurrency = bankCurrency
  }
}
